// extracted by mini-css-extract-plugin
export default {"header":"nav_header__cIIRx","hamburger":"nav_hamburger__yCAAN","open":"nav_open__LijzL","menuOverlay":"nav_menuOverlay__sVhPT","nav":"nav_nav__cFnJY"};